import { Button, Modal } from 'react-bootstrap';
import { useConfiguratorTranslations } from '../translations';
import type {
	ConfigurationListing,
	SavedConfigurationRow,
	UnavailableReason,
} from './types';

type Props = {
	reason: UnavailableReason;
	record: SavedConfigurationRow;
	onClose: () => void;
	onConfigureSimilar: (listing: ConfigurationListing) => void;
};

export function UnavailableConfigurationModal({
	reason,
	record,
	onClose,
	onConfigureSimilar,
}: Props) {
	const tr = useConfiguratorTranslations();
	const ref = record.vehicleRef;
	const period = ref ? `${ref.month}/${ref.year}` : '—';

	const body = {
		payload_invalid: tr.savedConfigPayloadInvalid,
		trim_delisted: tr.savedConfigTrimDelisted,
		listing_unavailable: tr.savedConfigListingUnavailable(period),
		options_invalid: tr.savedConfigOptionsInvalid,
		stock_sold: tr.savedConfigStockSold,
		excluded: tr.savedConfigExcluded,
		not_quotable: tr.savedConfigNotQuotable,
	}[reason];

	const canConfigureSimilar =
		!!record.listing?.makeCode && !!record.listing?.modelCode;

	return (
		<Modal show onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>{tr.savedConfigUnavailableTitle}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{body}</Modal.Body>
			<Modal.Footer>
				{canConfigureSimilar && (
					<Button
						variant="primary"
						onClick={() => onConfigureSimilar(record.listing)}
					>
						{tr.savedConfigConfigureSimilar}
					</Button>
				)}
				<Button variant="outline-secondary" onClick={onClose}>
					{tr.savedConfigClose}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
